import { jsx as _jsx } from "react/jsx-runtime";
import { useRequestDescriptor, useRequest } from '../request-view/useRequest';
import fetchToCurl from './fetchToCurl';
export function Curl() {
    const request = useRequest();
    const [mutableRequest] = useRequestDescriptor();
    const curl = fetchToCurl(request.url, mutableRequest);
    return (_jsx("div", { children: _jsx("pre", { className: "overflow-x-scroll p-2 text-xs text-zinc-600 dark:text-white/60", children: _jsx("code", { children: curl }) }) }));
}
